<template>
  <div class="pb-5 pt-2 container">

    <div class="d-flex align-items-center mb-3">
      <h1 class="me-2">Items</h1>
      <item-feed class="ms-auto" />
    </div>

    <static-alert v-if="errors" :message="errors" @on-hide="errors=''" />

    <div v-if="loaded">
      <inventory-item-list />
    </div>


  </div>
</template>

<script setup>
import ItemFeed from "@/app/components/inventory/ItemFeed.vue";
import {ref} from "vue";
import {useStore} from "vuex"
import StaticAlert from "@/app/components/Utils/StaticAlert.vue";
import InventoryItemList from "@/app/components/inventory/InventoryItemList.vue";

const store = useStore()
const loaded = ref(false)

store.dispatch("eshop/getInventory").then(() => loaded.value=true)

</script>

<style lang="scss" scoped>

</style>
